import { FunctionComponent } from 'react'

interface StepsInterface {
  step: number
  max: number
}

const Steps: FunctionComponent<StepsInterface> = ({ step, max }) => {
  const bars = Array(max)
    .fill(0)
    .map((_, i) =>
      step <= i ? (
        <div key={i} className="wc-progress-bar__bars-item"></div>
      ) : (
        <div
          key={i}
          className="wc-progress-bar__bars-item wc-progress-bar__bars-item--completed"
        ></div>
      )
    )

  return step > 0 && max > 0 ? (
    <div className="rte-container">
      <div className="wc-progress-bar">
        <div className="wc-progress-bar__numbers">
          <span className="wc-progress-bar__numbers-highlight">
            Step {step}
          </span>{' '}
          of {max}
        </div>
        <div className="wc-progress-bar__bars">{bars}</div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default Steps
